import { render } from "./fifthstepGrooming.vue?vue&type=template&id=443789bc&scoped=true"
import script from "./fifthstepGrooming.vue?vue&type=script&lang=js"
export * from "./fifthstepGrooming.vue?vue&type=script&lang=js"

import "./fifthstepGrooming.vue?vue&type=style&index=0&id=443789bc&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443789bc"]])

export default __exports__